export enum MppUserRegions {
  US = 'US',
  FR = 'FR',
}
